import { IAbstractRecord } from '@models';

export const transformReceivableBillsArrayToObject = (
  dataArray: IAbstractRecord[]
) => {
  if (!dataArray?.length) {
    return {};
  }

  const receivableBills = dataArray?.filter(
    (bill) => bill.accounting_Bills_BillType === 'RECEIVABLE'
  );

  return receivableBills.reduce((acc, item) => {
    if (acc[item.accounting_Bills_Id]) {
      // If the bill ID already exists, update the AmountPaid by summing it
      acc[item.accounting_Bills_Id].AmountPaid += Number(
        item.payableBills_AmountPaid || 0
      );
      acc[item.accounting_Bills_Id].TotalBalance =
        Number(acc[item.accounting_Bills_Id].AmountDue || 0) -
        Number(acc[item.accounting_Bills_Id].AmountReceived || 0) -
        (Number(acc[item.accounting_Bills_Id].Commission || 0) -
          Number(acc[item.accounting_Bills_Id].TaxOnCommission || 0) -
          acc[item.accounting_Bills_Id].AmountPaid);
    } else {
      // If the bill ID doesn't exist, initialize the entry
      acc[item.accounting_Bills_Id] = {
        Id: item.accounting_Bills_Id,
        BillNumber: item.accounting_Bills_BillNumber,
        DueDate: item.accounting_Bills_DueDate,
        AmountDue: item.accounting_Bills_AmountDue,
        TotalPremium: item.accounting_Bills_TotalPremium,
        AmountReceived: item.accounting_Bills_AmountReceived,
        Commission: item.accounting_Bills_TotalCommission,
        TaxOnCommission: item.accounting_Bills_TaxOnCommission,
        AmountPaid: item.payableBills_AmountPaid,
        TotalBalance:
          Number(item.accounting_Bills_AmountDue || 0) -
          Number(item.accounting_Bills_AmountReceived || 0) -
          (Number(item.accounting_Bills_TotalCommission || 0) -
            Number(item.accounting_Bills_TaxOnCommission || 0) -
            Number(item.payableBills_AmountPaid || 0)),
        Currency: item.accounting_Bills_Currency?.Symbol,
      };
    }
    return acc;
  }, {});
};
